import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PropertiesFormDependentSection({
  children,
  property
}) {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": `${property.name}-dependents`,
    borderStyle: "solid",
    borderWidth: "100",
    borderColor: "border-primary-subtle",
    borderInlineStartColor: "border-info-default",
    borderInlineStartWidth: "300",
    position: "relative",
    borderRadius: "100",
    marginBlockStart: "400",
    marginBlockEnd: "200",
    padding: "400",
    children: [/*#__PURE__*/_jsx(Small, {
      weight: "medium",
      children: /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "propertiesForm.dependentFieldsHelp",
          options: {
            label: property.label
          }
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "propertiesForm.dependentFieldsTitle"
        })
      })
    }), children]
  });
}
export default PropertiesFormDependentSection;